import { imgsPath } from '../../shared/config';

const Loading = () => {
  return (
    <div className="grid h-screen place-items-center">
      <div className="text-sm font-semibold text-center leading-3">
        <div className="animate-bounce">
          <img width="32" src={`${imgsPath}gdsuite/dna-icon.svg`} alt="" />
        </div>
        <div>Loading ...</div>
      </div>
    </div>
  );
};

export default Loading;
